import React, { FC } from 'react';

import { Button, HStack, Td, Text, Tr } from '@chakra-ui/react';

import { CustomSpinner } from 'components/DataDisplay/Spinner/CustomSpinner';

// Lines up with the name of a row one level down.
const INDENT_PX = 20;

interface NestedStatusRowProps {
  depth: number;
  isLoading?: boolean;
  // Shown with a Retry button.
  error?: string;
  message?: string;

  onRetry?(): void;
}

/**
 * A full-width row under an open database, schema or table: a spinner while
 * its contents load, an error with Retry, or a message such as "No tables".
 * A failure here leaves the rows above it in place.
 */
export const NestedStatusRow: FC<NestedStatusRowProps> = props => {
  const { depth, isLoading, error, message, onRetry } = props;
  return (
    <Tr bg="white">
      <Td colSpan={100} py={2} pl={`${16 + 28 + depth * INDENT_PX}px`}>
        {isLoading ? (
          <CustomSpinner size="sm" justify="flex-start" />
        ) : error ? (
          <HStack spacing={3}>
            <Text color="critical" fontSize="sm">
              {error}
            </Text>
            {onRetry && (
              <Button size="xs" variant="outline" onClick={onRetry}>
                Retry
              </Button>
            )}
          </HStack>
        ) : (
          <Text color="gray.400" fontSize="sm">
            {message}
          </Text>
        )}
      </Td>
    </Tr>
  );
};
